import React, { useEffect, useState } from 'react';

/**
 * A single labelled row with a proportional fill bar, sized relative to
 * `max` (not to a total) - for breakdowns whose values aren't mutually
 * exclusive, so they shouldn't be stacked as if they summed to 100%.
 */
export default function BarRow({
    label,
    value,
    max,
    colorClassName,
}: {
    label: string;
    value: number;
    max: number;
    colorClassName: string;
}) {
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const frame = requestAnimationFrame(() => setAnimate(true));
        return () => cancelAnimationFrame(frame);
    }, []);

    const percent = max > 0 ? (value / max) * 100 : 0;

    return (
        <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-secondary w-20 flex-shrink-0">{label}</span>
            <div className="flex-1 h-1.5 rounded-full bg-surface-muted overflow-hidden">
                <div
                    className={`h-full rounded-full ${colorClassName}`}
                    style={{
                        width: animate ? `${percent}%` : '0%',
                        transition: 'width 700ms cubic-bezier(0.33, 1, 0.68, 1)',
                    }}
                />
            </div>
            <span className="text-xs font-semibold text-foreground w-5 text-right flex-shrink-0">
                {value}
            </span>
        </div>
    );
}
